import Alert from "@reach/alert";
import { PropsWithChildren, useEffect, useState } from "react";
import invariant from "tiny-invariant";

export interface ToastOptions {
  key?: string;
}

export function Toast({ children }: PropsWithChildren<{}>) {
  return (
    <Alert className="toast bg-gray-800 text-white mx-auto my-2 p-1 rounded-md text-sm">
      {children}
    </Alert>
  );
}

interface ToastMessage {
  message: string;
  key: string;
}

export function Toaster({ children }: PropsWithChildren<{}>) {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  useEffect(() => {
    // @ts-ignore
    function addMessage(e) {
      const { key, message } = e.detail;

      invariant(typeof key === "string", "Key must be a string");
      invariant(typeof message === "string", "Message must be a string");

      if (messages.every((m) => m.key !== key)) {
        setMessages((prev) => {
          return [...prev, e.detail];
        });
        setTimeout(() => {
          setMessages((prev) => prev.slice(1));
        }, 4500);
      }
    }

    window.addEventListener("on-new-toast", addMessage, false);

    return () => {
      window.removeEventListener("on-new-toast", addMessage);
    };
  }, [messages]);

  return (
    <div className="z-50 fixed top-0 left-0 right-0 pointer-events-none flex flex-col justify-items-center">
      {messages.map((m) => (
        <Toast key={m.key}>{m.message}</Toast>
      ))}
      {children}
    </div>
  );
}

export function toast(message: string, options?: ToastOptions) {
  const key = options?.key || `${Date.now()}`;

  window.dispatchEvent(
    new CustomEvent<ToastMessage>("on-new-toast", { detail: { message, key } })
  );
}
